import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'

dayjs.extend(customParseFormat)
dayjs.extend(utc)

/**
 * Parses dates in backend format 'YYYY-MM-DD HH:mm:ss UTC' (Safari-incompatible) to ISO string.
 * Falls back to the current time when input is missing or unparseable to avoid crashing.
 */
export const parsePostDate = (dateStr: string | null | undefined): string => {
  if (dateStr?.endsWith(' UTC')) {
    const parsed = dayjs.utc(dateStr.replace(' UTC', ''), 'YYYY-MM-DD HH:mm:ss')
    if (parsed.isValid()) {
      return parsed.toISOString()
    }
  }
  const parsed = dayjs(dateStr)
  return parsed.isValid() ? parsed.toISOString() : new Date().toISOString()
}

export const getSuggestedPostTime = (initialTime = dayjs()): dayjs.Dayjs => {
  const now = dayjs()
  const isToday = initialTime.isSame(now, 'day')

  if (!isToday) return initialTime.hour(12).minute(0).second(0).millisecond(0)

  const hoursToAdd = now.minute() >= 30 ? 2 : 1
  return now.add(hoursToAdd, 'hour').minute(0).second(0).millisecond(0)
}
